const PUNTAJE_POINTS_PER_INSTALLMENT = 94;
const roundToDisplayPrecision = (value) =>
  Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

export const formatInstallments = (value) => {
  const safeValue = Number(value || 0);
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safeValue);
};

/**
 * Convierte cuotas equivalentes a puntos de Puntaje Habitat.
 *
 * @param {number|string} installments Cantidad de cuotas equivalentes.
 * @returns {number} Puntaje calculado con el coeficiente vigente.
 */
export const calculatePuntajePoints = (installments) =>
  roundToDisplayPrecision(installments) * PUNTAJE_POINTS_PER_INSTALLMENT;

/**
 * Formatea en es-AR el puntaje derivado de cuotas equivalentes.
 *
 * @param {number|string} installments Cantidad de cuotas equivalentes.
 * @returns {string} Puntaje formateado con dos decimales.
 */
export const formatPuntajePoints = (installments) =>
  formatInstallments(calculatePuntajePoints(installments));

export const formatInteger = (value) =>
  new Intl.NumberFormat('es-AR', {
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const formatDateTime = (value, withTime = true) => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat('es-AR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(withTime
      ? {
          hour: '2-digit',
          minute: '2-digit',
        }
      : {}),
  }).format(date);
};

export const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.message ||
  fallbackMessage;

export const getGroupLabel = (group) => group?.name || group?.group_name || 'Grupo sin nombre';

export const getMovementChipColor = (movementType) => {
  if (movementType === 'CREDIT') return 'success';
  if (movementType === 'DEBIT') return 'error';
  if (movementType === 'ADJUSTMENT') return 'info';
  if (movementType === 'INITIAL_BALANCE') return 'default';
  return 'warning';
};

const prettifyKey = (value) =>
  String(value || '')
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ');

export const getMovementTypeLabel = (movementType) => {
  if (movementType === 'CREDIT') return 'Crédito';
  if (movementType === 'DEBIT') return 'Débito';
  if (movementType === 'ADJUSTMENT') return 'Ajuste';
  if (movementType === 'INITIAL_BALANCE') return 'Saldo inicial';
  return prettifyKey(movementType) || '-';
};

export const getMovementSourceLabel = (sourceType) => {
  if (sourceType === 'COUPON_MONTHLY') return 'Cupón mensual';
  if (sourceType === 'COUPON_SCORE') return 'Cupón con puntaje';
  if (sourceType === 'COUPON_ADVANCE') return 'Adelanto';
  if (sourceType === 'PRE_ADJUDICATION') return 'Preadjudicación';
  if (sourceType === 'LEGACY_PREADJUDICATION') return 'Preadjudicación';
  if (sourceType === 'SORTEO_FINANCING_INSTALLMENT') return 'Financiamiento por sorteo';
  if (sourceType === 'INITIAL_BALANCE') return 'Saldo inicial';
  if (sourceType === 'MANUAL_ADJUSTMENT') return 'Ajuste manual';
  if (sourceType === 'LOTTERY_RESULT') return 'Resultado de lotería';
  return prettifyKey(sourceType) || '-';
};

export const getPreAdjudicationChipColor = (preAdjudicationType) => {
  if (preAdjudicationType === 'PUNTAJE') return 'success';
  if (preAdjudicationType === 'SORTEO') return 'warning';
  if (preAdjudicationType === 'DESBORDE') return 'info';
  return 'default';
};
